var render = function render(){var _vm=this,_c=_vm._self._c;return _c('InstructionScreen',{attrs:{"title":'Total points'}},[_vm._v(" You have completed the experiment! "),_c('br'),_vm._v(" You have earned a total of "+_vm._s(_vm.totalPoints)+" out of 32 points across all trials ("+_vm._s(Math.round(_vm.totalPoints / 32 * 100))+"%). "),_c('br'),_c('Record',{attrs:{"data":{
          total_points: _vm.totalPoints,
          total_points_percentage: Math.round(_vm.totalPoints / 32 * 100)
        },",":"","global":"true"}}),_vm._v(" Please click 'Next' to proceed to the post-test questionnaire and submit the results. ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }